import React from "react"
import Helmet from "react-helmet"
import { useLocation } from "@reach/router"
import "../styles/pc.scss"
import "../styles/sp.scss"

export default function Seo({
    title,
    type,
    path,
    description,
    socialTitle,
    socialDescription,
    socialPublishedTime,
    socialModifiedTime,
    bobyClassName,
}) {
    let pageTitle = title + " | J.Feel"
    let pageDescription = description ?? "「仕事が面白い」「職場が楽しい」「会社が好きだ」と、感じていますか？ジェイフィールは五感を使った人材育成（管理職研修やOJT研修など）を通じて、組織変革のお手伝いをします。"
    let pageType = type ?? "article";
    let pageSocialTitle = socialTitle ?? pageTitle;
    let pageSocialDescription = socialDescription ?? pageDescription;
    const location = useLocation()
    let url = 'https://www.j-feel.jp' + location.pathname;
    
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      "name": pageTitle,
      "url": url,
      "description": pageDescription
    };

  return (
    <Helmet>
      <body className={bobyClassName} />

      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content="管理職,研修,人材育成,マネジメント,リーダーシップ,組織活性化,OJT,不機嫌な職場,野田稔,高橋克徳,重光直之,ジェイフィール,リフレクションラウンドテーブル" />
 
      <meta charSet="utf-8" />
      <meta name="Author" content="J.Feel" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="content-Type" content="text/html;charset=utf-8" />
      <meta httpEquiv="content-script-type" content="text/javascript" />
      <meta httpEquiv="content-style-type" content="text/css" />
      <meta name="robots" content="all" />

      {/* OGP設定 */}
      <meta property="og:type" content="article" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content="人と組織と社会のつながりを再生し、未来へつなぐ。 株式会社ジェイフィール" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="j-feel.jp" />
      <meta property="og:image" content="https://www.j-feel.jp/images/sns-thumbnail/jfeel.jpg" />

      {/* twitter設定 */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@JFEELofficial" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description"content="人と組織と社会のつながりを再生し、未来へつなぐ。 株式会社ジェイフィール" />
      <meta name="twitter:image" content="https://www.j-feel.jp/images/sns-thumbnail/jfeel.jpg" />
      <meta name="twitter:url" content={url} />

      {socialPublishedTime && (
          <meta property="article:published_time" content={socialPublishedTime} />
      )}
      {socialModifiedTime && (
          <meta property="article:published_time" content={socialModifiedTime} />
      )}

      {/* canonical */}
      <link rel="canonical" href={url} />

      {/* googlefont */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@600;700;900&display=swap" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,800;1,500&family=Noto+Sans+JP:wght@900&display=swap" rel="stylesheet" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      {/* /googlefont */}

      <link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
      <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />

      {/* munchkin */}
      <script type="text/javascript">
        {`
          (function() {
            var didInit = false;
            function initMunchkin() {
              if(didInit === false) {
                didInit = true;
                Munchkin.init('710-VHD-896', {"domainLevel":2}, {"asyncOnly": true});
              }
            }
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = '//munchkin.marketo.net/munchkin.js';
            s.onreadystatechange = function() {
              if (this.readyState == 'complete' || this.readyState == 'loaded') {
                initMunchkin();
              }
            };
            s.onload = initMunchkin;
            document.getElementsByTagName('head')[0].appendChild(s);
          })();
        `}
      </script>
      {/* munchkin */}

      {/* structured data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      {/* structured data */}
    </Helmet>
  )
}
